/**
 * MagicTong PDP hover zoom — classic side magnifier pane (desktop fine pointer only).
 * Follows cursor over the active product image; uses the image's currentSrc / largest srcset.
 */
(function () {
  var mq = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!mq.matches) return;

  var SCALE = 2.4;
  var pane = null;
  var lens = null;
  var activeImg = null;
  var mediaRoot = null;
  var bound = false;

  function ensureUi() {
    if (pane) return;
    pane = document.createElement('div');
    pane.className = 'mt-hover-zoom';
    pane.setAttribute('aria-hidden', 'true');
    lens = document.createElement('div');
    lens.className = 'mt-hover-zoom__lens';
    lens.setAttribute('aria-hidden', 'true');
    document.body.appendChild(pane);
    document.body.appendChild(lens);
  }

  function hide() {
    if (!pane) return;
    pane.classList.remove('is-on');
    lens.classList.remove('is-on');
    pane.style.backgroundImage = '';
    activeImg = null;
  }

  function findActiveImg(root) {
    var slide =
      root.querySelector('slideshow-slide[aria-hidden="false"]') ||
      root.querySelector('.slideshow-slide[aria-hidden="false"]');
    if (!slide) {
      // single image / grid fallback
      slide = root.querySelector('.product-media-container--image') || root;
    }
    return (
      slide.querySelector('.product-media img') ||
      slide.querySelector('img') ||
      null
    );
  }

  function hiResUrl(img) {
    if (!img) return '';
    // Prefer largest candidate from srcset
    var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    if (srcset) {
      var best = '';
      var bestW = 0;
      srcset.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var url = bits[0];
        var w = 0;
        if (bits[1] && /w$/.test(bits[1])) w = parseInt(bits[1], 10) || 0;
        if (w >= bestW) {
          bestW = w;
          best = url;
        }
      });
      if (best) return best;
    }
    return img.currentSrc || img.src || '';
  }

  function layoutPane(imgRect) {
    var gap = 16;
    var size = Math.min(imgRect.width, imgRect.height);
    var left = imgRect.right + gap;
    var top = imgRect.top;
    // If it would overflow viewport, place over details still clamped
    var maxRight = window.innerWidth - 12;
    if (left + size > maxRight) {
      left = Math.max(12, maxRight - size);
    }
    var maxBottom = window.innerHeight - 12;
    if (top + size > maxBottom) {
      top = Math.max(12, maxBottom - size);
    }
    pane.style.width = size + 'px';
    pane.style.height = size + 'px';
    pane.style.left = left + 'px';
    pane.style.top = top + 'px';
    return size;
  }

  function onMove(e) {
    if (!mediaRoot || !pane) return;
    // ignore when over arrows / thumbnails / controls
    if (e.target.closest && e.target.closest('slideshow-arrows, .slideshow-controls, .slideshow-control, button, a')) {
      hide();
      return;
    }
    var img = findActiveImg(mediaRoot);
    if (!img || !img.naturalWidth) {
      hide();
      return;
    }
    var rect = img.getBoundingClientRect();
    if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
      hide();
      return;
    }

    if (activeImg !== img) {
      activeImg = img;
      var url = hiResUrl(img);
      pane.style.backgroundImage = 'url("' + url.replace(/"/g, '\\"') + '")';
      pane.style.backgroundRepeat = 'no-repeat';
    }

    var paneSize = layoutPane(rect);
    var x = (e.clientX - rect.left) / rect.width;
    var y = (e.clientY - rect.top) / rect.height;
    x = Math.max(0, Math.min(1, x));
    y = Math.max(0, Math.min(1, y));

    var bgW = rect.width * SCALE;
    var bgH = rect.height * SCALE;
    pane.style.backgroundSize = bgW + 'px ' + bgH + 'px';
    pane.style.backgroundPosition =
      -(x * (bgW - paneSize)) + 'px ' + -(y * (bgH - paneSize)) + 'px';

    // lens size relative to scale
    var lensW = rect.width / SCALE;
    var lensH = rect.height / SCALE;
    // for square pane vs possibly square image, lens matches visible fraction of pane
    lensW = Math.min(lensW, rect.width);
    lensH = Math.min(lensH, rect.height);
    var lx = e.clientX - lensW / 2;
    var ly = e.clientY - lensH / 2;
    lx = Math.max(rect.left, Math.min(rect.right - lensW, lx));
    ly = Math.max(rect.top, Math.min(rect.bottom - lensH, ly));
    lens.style.width = lensW + 'px';
    lens.style.height = lensH + 'px';
    lens.style.left = lx + 'px';
    lens.style.top = ly + 'px';

    pane.classList.add('is-on');
    lens.classList.add('is-on');
  }

  function onLeave() {
    hide();
  }

  function bind(root) {
    mediaRoot = root;
    ensureUi();
    if (bound) return;
    bound = true;
    root.addEventListener('mousemove', onMove);
    root.addEventListener('mouseleave', onLeave);
    window.addEventListener(
      'scroll',
      function () {
        hide();
      },
      { passive: true }
    );
  }

  function boot() {
    var root = document.querySelector('.product-information__media');
    if (!root) return;
    bind(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Section re-render / variant swap
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
})();
